import React, { useState } from "react";
import PropTypes from "prop-types";

import Button from "components/common/Button";
import CreateOneTimeChargeModal from "components/common/CreateOneTimeChargeModal";

function CreateOneTimeChargeButton({ onViewCharge, isLoading = false, className = "" }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleConfirm = () => {
    handleCloseModal();
  };

  return (
    <>
      <Button
        variant="outlined"
        size="medium"
        onClick={handleOpenModal}
        label="Create One-time Charge"
        className={className}
      />

      <CreateOneTimeChargeModal
        open={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirm}
        onViewCharge={onViewCharge}
        isLoading={isLoading}
      />
    </>
  );
}

CreateOneTimeChargeButton.propTypes = {
  onViewCharge: PropTypes.func,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
};

CreateOneTimeChargeButton.defaultProps = {
  onViewCharge: null,
  isLoading: false,
  className: "",
};

export default CreateOneTimeChargeButton;
